/*
 * @Author: yeyimei
 * @Date: 2022-09-22 17:09:10
 * @LastEditTime: 2024-03-29 18:12:25
 * @LastEditors: yeyimei
 * @Description:
 * @FilePath: \cardlan-h5-qrcode\src\libs\gcontrol.js
 */
import { Dialog } from "vant"
import { saveDurationUpdateApi } from "@/utils/api"
import store from "../store/index.js"
import {
  getStorage,
  getAppIdStorage,
  setAppIdStorage,
  setStorage,
  setSession,
} from "../libs/storage"
const wx = require("weixin-js-sdk")
let appId = getStorage("appId") || "wx9a373b1354d442cf"

//土特产：wxfcb34416b1538017   H5公众号:wx9a373b1354d442cf
//调试土特产H5时需要把appId换成wxfcb34416b1538017,调试完切记换会wx9a373b1354d442cf
let H5_APPID = "wx9a373b1354d442cf"
let INFOS_STORAGE = getAppIdStorage(appId) || {}

/**
 * @description 确认提示模态框
 * @param {string} msg
 * @param {function(): void} [confirm]
 * @param {string} [title]
 * @param {string} [confirmText]
 */
export const dialog = (msg, title = "", text = "确定") => {
  return new Promise((resolve) => {
    Dialog.alert({
      title: title,
      message: msg,
      confirmButtonText: text,
    }).then(() => {
      resolve(true)
    })
  })
}
/**
 * @description 确定取消提示模态框-异步
 * @param {string} msg
 * @param {string} [title]
 * @param {string} [confirmText]
 * @param {string} [cancelText]
 * @return {Promise<boolean>} true-确认，false-取消
 */
export const confirmModal = (msg, title, confirmText, cancelText,confirmColor,cancelColor) => {
  return new Promise((resolve) => {
    Dialog.confirm({
      title: title || (title === "" ? "" : "温馨提示"),
      message: msg,
      confirmButtonText: confirmText || "确定",
      cancelButtonText: cancelText || "取消",
      cancelButtonColor:  cancelColor || "#6f6f6f",
      confirmButtonColor:  confirmColor || "#0570db",
      allowHtml: true,
    })
      .then(() => {
        resolve(true)
      })
      .catch(() => {
        resolve(false)
      })
  })
}

//获取url中的参数
export const getUrlParams = (url, handleUrl) => {
  if (url.indexOf("?") !== -1) {
    let obj = {}
    let newUrl = url.substring(url.indexOf("?") + 1)
    // 去掉 hash 部分，避免影响查询参数解析
    if (newUrl.indexOf("#") !== -1) {
      newUrl = newUrl.substring(0, newUrl.indexOf("#"))
    }
    var b = newUrl.split("&")
    for (let i = 0; i < b.length; i++) {
      obj[b[i].split("=")[0]] = b[i].split("=")[1]
    }
    let environment = getStorage("environment")

    //公众号默认appId:wx9a373b1354d442cf
    if(obj.appid){
      appId = obj.appid
      setStorage("appId", obj.appid)
    }else {
      setStorage("appId", H5_APPID)
    }

    if (obj.ticket) {
      let infos_storage = getAppIdStorage(appId) || {}
      infos_storage.Ticket = obj.ticket
      infos_storage.m = obj.m
      if (infos_storage.userInfo) {
        infos_storage.userInfo.ticket = obj.ticket
      }
      setAppIdStorage(appId, infos_storage)
    }

    if (handleUrl !== "handleUrl") {
      //防止页面跳转就执行
      console.log("appId------>",appId);
      appId = getStorage("appId")
      console.log("appId111111------>",appId);
      let infos_storage = getAppIdStorage(appId) || {}
      delete infos_storage.distUserInfo
      infos_storage.showBack = "true"
      if (obj.mercode) {
        infos_storage.mercode = obj.mercode
      }

      //处理接收扩展码
      if (infos_storage.ext) {
        infos_storage.ext = ""
      }
      if (obj.ext) {
        infos_storage.ext = obj.ext
      }

      //移动积分兑换页面需要的 通道id和扩展码code
      if (obj.m === "integral" && obj.pid && obj.pid !== "undefined") {
        let integralObj = {
          pid: Number(obj.pid),
        }
        setSession("integralObj", integralObj)
      }

      //免费领券根据传过来的code,跳转到免费领券首页指定分类
      if (obj.m === "activity" && obj.code) {
        setSession("activityCode", obj.code)
      }

      //控制页面是否显示返回图标
      if (obj.b) {
        if (obj.b == 1) {
          infos_storage.showBack = "false"
          store.commit("showBack", "false")
        }
      } else {
        store.commit("showBack", "true")
      }

      //处理小程序直接跳H5  当H5环境来走
      if (obj.c) {
        infos_storage.c = obj.c
        if (obj.m) {
          infos_storage.m = obj.m
        }
      }
      setAppIdStorage(appId, infos_storage)
      //当c=h5时，是第三方小程序嵌套H5，想直接按照h5环境来走，推的是不涉及支付的单页面
      if (infos_storage.c === "h5") {
        store.commit("showBack", "false")
      }
    }
    return obj
  }
}

//处理每个页面Url 给每个页面的url添加上mercode
export const handleUrl = (url) => {
  //是index页面则不需要添加mercode
  if (url.indexOf("/index") >= 0) return url
  if (url.indexOf("?") >= 0) {
    let obj = getUrlParams(url, "handleUrl")
    let mercode = INFOS_STORAGE.mercodeUrl || "10"
    //有mercode则覆盖，没有则赋值
    obj.mercode = mercode
    let params = ""
    for (let key in obj) {
      params = `${params}&${key}=${obj[key]}`
    }
    return `${url.split("?")[0]}?${params.replace("&", "")}`
  } else {
    let mercode = INFOS_STORAGE.mercodeUrl || "10"
    return `${url}?mercode=${mercode}`
  }
}

//url字符串截取
export const getQueryString = (key, url) => {
  var reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)")
  let result
  if (url) {
    result = url.slice(url.indexOf("?")).substr(1).match(reg)
  } else {
    result = window.location.search.substr(1).match(reg)
  }
  return result ? decodeURIComponent(result[2]) : null
}

//替换url中指定的参数
export const changeURLArg = (url, arg, arg_val) => {
  var pattern = arg + "=([^&]*)"
  var replaceText = arg + "=" + arg_val
  if (url.match(pattern)) {
    var tmp = "/(" + arg + "=)([^&]*)/gi"
    tmp = url.replace(eval(tmp), replaceText)
    return tmp
  } else {
    if (url.match("[?]")) {
      return url + "&" + replaceText
    } else {
      return url + "?" + replaceText
    }
  }
  return url + "\n" + arg + "\n" + arg_val
}

//在url中添加标识符，防止缓存中的appId被扰乱，通过url中的标识符去读取缓存
export const handleUrlStorage = (toPath, fromPath) => {
  let appId = getStorage("appId") || 'wx9a373b1354d442cf'
  if (!getQueryString("k", fromPath)) {
    let keyName = appId?.substring(appId.length - 6)
    let url = changeURLArg(toPath, "k", keyName)
    return url
  } else {
    let keyName = getQueryString("k")
    return toPath.indexOf("?") < 0
      ? `${toPath}?k=${keyName}`
      : `${toPath}&k=${keyName}`
  }
}

export const getSystem = () => {
  var ua = navigator.userAgent.toLowerCase()
  var isWeixin = ua.indexOf("micromessenger") != -1
  if (isWeixin) {
    var version = ""
    var wechatInfo = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i)
    if (wechatInfo && wechatInfo.length > 1) {
      // 获取微信的版本号
      localStorage.setItem("wxVersion", wechatInfo[1])
    }
  }
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
    wx.miniProgram.getEnv((res) => {
      if (res.miniprogram) {
        //在小程序里
        // localStorage.setItem("environment", "weixin")
        store.commit("environment","weixin")
      } else {
        //在微信浏览器中
        // localStorage.setItem("environment", "wxBrowser")
        store.commit("environment","wxBrowser")
      }
    })
  } else {
    //不在微信中
    // localStorage.setItem("environment", "outBrowser")
    store.commit("environment","outBrowser")
  }
}

// 全局判断是否IOS方法
export const isIos = () => {
  const u = navigator.userAgent
  return u.indexOf("iPhone") > -1 || u.indexOf("Mac OS") > -1
}

//数组去重
export const norepeat = (arr) => {
  //arr是要去重的数组
  var newarr = [] //准备用来存放去重之后的数据
  arr.forEach(function (item) {
    if (!newarr.includes(item)) {
      //不包含
      newarr.push(item)
    }
  })
  return newarr
}

export const saveDurationUpdate = (id) => {
    let count = 0
    let timer = null
    timer = setInterval(() => {
      if (count >= 60) {
        clearInterval(timer)
      } else {
        count++
        saveDurationUpdateApi(id)
      }
    }, 5000)
    return timer
}
